import {
	BarController,
	BarElement,
	CategoryScale,
	Chart,
	Legend,
	LinearScale,
	Tooltip,
} from "chart.js";
import ChartjsPluginWatermark from "chartjs-plugin-watermark";
import jQuery from "jquery";
import { legendButtonsPlugin, legendColumnsPlugin } from "./plugins";
import {
	addBlankLinesToYAxis,
	drillDownChart,
	initShowHideAll,
	prepareForPrint,
} from "./utils";

// FIXME this is a work-around to TEMPORARILY get airline profile page to work that have a global dependency on jQuery
/* global $ */
window.jQuery = window.$ = jQuery;
const watermarkConfig = {
	image: "/static/img/logo.svg",
	width: 350,
	height: 80,
	opacity: 0.1,
	alignX: "middle",
	alignY: "top",
	alignToChartArea: true,
	position: "front",
};

Chart.register(
	BarController,
	BarElement,
	CategoryScale,
	ChartjsPluginWatermark,
	LinearScale,
	Legend,
	Tooltip,
);

export function renderChart(
	data,
	id,
	chartType,
	legendId,
	imgElementId = null,
	maintainAspectRatio = true,
) {
	const ctx = document.getElementById(id).getContext("2d");
	const chart = new Chart(ctx, {
		type: chartType,
		data: data[0],
		options: {
			animation: {
				onComplete: () => prepareForPrint(imgElementId, chart),
			},
			maintainAspectRatio,
			plugins: {
				legendButtonsPlugin: {
					containerID: legendId,
				},
				legend: {
					display: false,
				},
				tooltip: {
					intersect: false,
					mode: "index",
				},
			},
			responsive: true,
			scales: {
				x: {
					stacked: true,
					grid: {
						display: false,
					},
				},
				y: {
					stacked: true,
					border: {
						display: false,
					},
					ticks: {
						min: 0,
						callback: (value, index, values) => {
							this.max = values[0];
							if (Math.floor(value) === value) {
								return value;
							}
						},
					},

					afterTickToLabelConversion: (axis) =>
						addBlankLinesToYAxis(axis),
				},
			},
			watermark: watermarkConfig,
		},
		plugins: [legendButtonsPlugin],
	});
}

export function renderChartWithLegend(
	apiUrl,
	id,
	chartType,
	legendPosition = "bottom",
	legendId = null,
	initialChart = false,
	multipleSelectionButtonId = null,
	imgElementId = null,
	maintainAspectRatio = true,
	chartCategory = null,
	uniqueVariantsCount = 0,
) {
	const canvas = document.getElementById(id);
	const ctx = canvas.getContext("2d");
	const modal = canvas.closest(".modal");

	$.get(apiUrl).done((data) => {
		if (typeof data === "object" && Object.hasOwn(data, "datasets")) {
			const chart = new Chart(ctx, {
				type: chartType,
				data: data,
				options: {
					onClick: (e) =>
						drillDownChart(
							e,
							chart,
							chartCategory,
							uniqueVariantsCount,
						),
					responsive: true,
					maintainAspectRatio,
					scales: {
						x: {
							barPercentage: 0.6,
							stacked: true,
							grid: {
								display: false,
							},
						},
						y: {
							stacked: true,
							ticks: {
								autoSkip: false,
								min: 0,
								beginAtZero: true,
								callback: (value) => {
									if (Math.floor(value) === value) {
										return value;
									}
								},
							},
							afterTickToLabelConversion: (axis) =>
								addBlankLinesToYAxis(axis),
						},
					},
					plugins: {
						legend: {
							display: !legendId,
							position: legendPosition,
							align: "left",
						},
						legendColumnsPlugin: {
							containerID: legendId,
						},
						tooltip: {
							mode: "nearest",
							intersect: true,
						},
					},
					animation: !modal && {
						onComplete: () => prepareForPrint(imgElementId, chart),
					},
					watermark: watermarkConfig,
				},
				plugins: [legendColumnsPlugin],
			});

			initShowHideAll(multipleSelectionButtonId, chart);
		} else {
			if (initialChart) {
				// Check used aircraft, if it's empty do not display chart block
				const usedAircraftApiUrl = apiUrl.replace(
					"new-aircraft",
					"used-aircraft",
				);
				$.get(`${usedAircraftApiUrl}`).done((data) => {
					if (data.length === 0) {
						$("#" + id)
							.closest(".chart")
							.remove();
					}
				});
			} else {
				$("#" + id)
					.closest(".chart")
					.remove();
			}
		}

		const loading = canvas?.parentElement?.previousElementSibling;

		if (loading) {
			loading.classList.add("loaded");
		}
	});
}

window.renderChart = renderChart;
window.renderChartWithLegend = renderChartWithLegend;
